<template>
  <div class="p-4 grid grid-cols-2 gap-4">
    <!-- Trip Matrix -->
    <div class="border border-zinc-300 dark:border-zinc-700 rounded-lg overflow-hidden flex flex-col" v-if="createStore.plan.modules.tm.write">
      <div class="p-4">
        <p>Presents person trips between zones in a study area.</p>
      </div>
      <div class="grow"></div>
      <RouterLink
        class="text-zinc-50 flex space-x-2 items-center justify-center p-2 border border-accent bg-accent/75 hover:bg-accent focus:outline-none"
        to="studies/create">Trip Matrix</RouterLink>
    </div>
    <!-- Select Link Trip Matrix -->
    <div class="border border-zinc-300 dark:border-zinc-700 rounded-lg overflow-hidden flex flex-col" v-if="createStore.plan.modules.sltm.write">
      <div class="p-4">
        <p>Presents origin and destination of vehicle trips along a roadway link.</p>
      </div>
      <div class="grow"></div>
      <RouterLink
        class="text-zinc-50 flex space-x-2 items-center justify-center p-2 border border-accent bg-accent/75 hover:bg-accent focus:outline-none"
        to="studies/create-select-link">Select Link Trip Matrix</RouterLink>
    </div>
    <!-- Volume & Speed -->
    <div class="border border-zinc-300 dark:border-zinc-700 rounded-lg overflow-hidden flex flex-col" v-if="createStore.plan.modules.sv.write">
      <div class="p-4">
        <p>Presents speeds, volumes, and other characteristics of a roadway link.</p>
      </div>
      <div class="grow"></div>
      <RouterLink
        class="text-zinc-50 flex space-x-2 items-center justify-center p-2 border border-accent bg-accent/75 hover:bg-accent focus:outline-none"
        to="studies/create-speed-volume">Volume &amp; Speed</RouterLink>
    </div>
    <!-- Intersection Analysis -->
    <div class="border border-zinc-300 dark:border-zinc-700 rounded-lg overflow-hidden flex flex-col" v-if="createStore.plan.modules.ia.write">
      <div class="p-4">
        <p>Presents intersection turning movement volume estimates.</p>
      </div>
      <div class="grow"></div>
      <RouterLink
        class="text-zinc-50 flex space-x-2 items-center justify-center p-2 border border-accent bg-accent/75 hover:bg-accent focus:outline-none"
        to="studies/create-intersection-analysis">Intersection Analysis</RouterLink>
    </div>
    <!-- Safety Analysis -->
    <div class="border border-zinc-300 dark:border-zinc-700 rounded-lg overflow-hidden flex flex-col" v-if="createStore.plan.modules.sa.write">
      <div class="p-4">
        <p>Presents locations of excessive speeds and high frequency of vehicle harsh braking events.</p>
      </div>
      <div class="grow"></div>
      <RouterLink
        class="text-zinc-50 flex space-x-2 items-center justify-center p-2 border border-accent bg-accent/75 hover:bg-accent focus:outline-none"
        to="studies/create-intersection-analysis">Safety Analysis</RouterLink>
    </div>
    <!-- Pedestrian Activity Density Analysis -->
    <div class="border border-zinc-300 dark:border-zinc-700 rounded-lg overflow-hidden flex flex-col" v-if="createStore.plan.modules.pad.write">
      <div class="p-4">
        <p>Presents areas with high concentrations of non-motorized activity within a study area.</p>
      </div>
      <div class="grow"></div>
      <RouterLink
        class="text-zinc-50 flex space-x-2 items-center justify-center p-2 border border-accent bg-accent/75 hover:bg-accent focus:outline-none"
        to="studies/create-pad-analysis">Pedestrian Activity Density</RouterLink>
    </div>
  </div>
</template>

<script setup>
import { RouterLink } from "vue-router";
import { useCreateStore } from "@/stores/create";
const createStore = useCreateStore();
</script>